import React, { useState } from 'react'
import { TableRow, TableCell, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useDeleteSalesIncentive } from '../../../api/sales-commission-incentive'
import { getErrorMessage } from '../../../api/utils'
import { useSnackbar } from 'notistack'
import moment from 'moment'
import ConfirmDeleteDialog from '../../../component/shared/component/ConfirmDeleteDialog'
import { formatNumber } from '../../../utils/number'

const IncentiveRow = ({ data, onEdit, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync: deleteIncentive, isLoading: isDeleting } = useDeleteSalesIncentive()

  const handleDelete = async () => {
    try {
      await deleteIncentive(data._id)
      enqueueSnackbar('Incentive deleted', { variant: 'success' })
      refetch()
      setOpenDelete(false)
    } catch (err) {
      enqueueSnackbar(getErrorMessage(err), { variant: 'error' })
    }
  }

  return (
    <>
      <TableRow hover>
        <TableCell>{data.description}</TableCell>
        <TableCell>{data.salesId}</TableCell>
        <TableCell>{formatNumber(data.amount)}</TableCell>
        <TableCell>
          {data.transactionYearMonth
            ? moment(data.transactionYearMonth, 'YYMM').format('MMMM YYYY')
            : '-'}
        </TableCell>
        <TableCell align='right'>
          <IconButton onClick={onEdit} color='primary' size='small'>
            <EditIcon fontSize='small' />
          </IconButton>
          <IconButton onClick={() => setOpenDelete(true)} color='error' size='small'>
            <DeleteIcon fontSize='small' />
          </IconButton>
        </TableCell>
      </TableRow>
      <ConfirmDeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title='Delete Incentive'
        message={`Are you sure you want to delete this incentive for ${data.salesId}?`}
        isLoading={isDeleting}
      />
    </>
  )
}

export default IncentiveRow
